const baseClass = 'main-nav__item';
const buttonSelector = '.main-nav__button';
const targetSelector = '.main-nav__list--level-2';
const openClass = `${baseClass}--open`;
const initHeight = '100vh';

let menuItemsInfos = [];
[...document.querySelectorAll(`.${baseClass}`)].forEach((menuItem) => {
    const classList = menuItem.classList;
    const trigger = menuItem.querySelector(buttonSelector);
    const target = menuItem.querySelector(targetSelector);
    if (trigger && target) {
        menuItemsInfos.push({
            classList,
            trigger,
            target,
        });
    }
});

menuItemsInfos.forEach(({ classList, trigger, target, ignoredElementsInTrigger }) => {
    target.dataset.maxHeight = initHeight;
    trigger.addEventListener('click', (event) => {
        // This disables the click on the anchor
        event.preventDefault();
        event.stopImmediatePropagation();
        trigger.blur();
        const open = classList.contains(openClass);
        classList.toggle(openClass);
        if (open) {
            target.style.maxHeight = 0;
        } else {
            target.style.maxHeight = target.dataset.maxHeight;
        }
        setTimeout(() => {
            if (classList.contains(openClass) && target.dataset.maxHeight == initHeight) {
                setMaxHeight(target);
            }
        }, 300);
    });
});

function setMaxHeight(element) {
    element.style.maxHeight = 'none';
    const height = element.offsetHeight;
    element.style.maxHeight = height + 20 + 'px';
    element.dataset.maxHeight = height + 20 + 'px';
}

let timeout;
window.addEventListener('resize', () => {
    if (timeout) {
        window.cancelAnimationFrame(timeout);
    }

    timeout = window.requestAnimationFrame(function () {
        menuItemsInfos.forEach(({ classList, target }) => {
            if (classList.contains(openClass)) {
                setMaxHeight(target);
            } else {
                target.dataset.maxHeight = initHeight;
            }
        });
    });
});
